import { useRenderToasters } from 'hooks/useRenderToasters'

import { useUpdateBillingAddress } from '../../Forms/BillingAddressForm/billingAddressForm.hooks'
import { useUpdateShippingAddress } from '../../Forms/ShippingAddressForm/shippingAddressForm.hooks'

export const useUpdateAddresses = () => {
  const { renderSuccessToast, renderErrorToast } = useRenderToasters()
  const { updateShippingAddress, loading: isUpdatingShippingAddress } =
    useUpdateShippingAddress({
      onError: () => {
        renderErrorToast({
          title: 'Error',
          description: 'Error updating the shipping address.',
        })
      },
      onCompleted: (data) => {
        if (data.updateOrderShipping.errors?.length) {
          renderErrorToast({
            title: 'Error',
            description: 'Error updating the shipping address.',
          })
        } else {
          renderSuccessToast({
            title: 'Success',
            description: 'Shipping address updated successfully.',
          })
        }
      },
    })

  const { updateBillingAddress, loading: isUpdatingBillingAddress } =
    useUpdateBillingAddress({
      onError: () => {
        renderErrorToast({
          title: 'Error',
          description: 'Error updating the billing address.',
        })
      },
      onCompleted: (data) => {
        if (data.updateOrderBilling.errors?.length) {
          renderErrorToast({
            title: 'Error',
            description: 'Error updating the billing address.',
          })
        } else {
          renderSuccessToast({
            title: 'Success',
            description: 'Billing address updated successfully.',
          })
        }
      },
    })

  return {
    updateBillingAddress,
    updateShippingAddress,
    isUpdatingBillingAddress,
    isUpdatingShippingAddress,
  }
}
